<template>
  <BjDrawerForm ref="BjDrawerForm" class="view-container" :form="form" :rules="rules" label-width="120px" width="800px" @handleConfirm="handleConfirm">
    <template>
      <BjDivider>{{ $t('BusinessPurchaseSupplier.dataForm.title') }}
        <template v-if="isEdit" #right>
          <el-button type="primary" @click="showLog">{{ $t('BusinessPurchaseSupplier.dataForm.titleBtn') }}</el-button>
        </template>
      </BjDivider>
      <el-row>
        <el-col :span="12">
        <BjFormItemCode v-model="form.code" :label="$t('BusinessPurchaseSupplier.dataForm.code')" prop="code" :disabled="isEdit" required />
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.name')" prop="name">
          <BjInput v-model="form.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.classify')" prop="type">
            <BjInput v-model="form.type" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.company')" prop="fullName">
            <BjInput v-model="form.fullName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
          <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.supplierGrade')" prop="level">
            <BjInput v-model="form.level" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.mnemonicCode')" prop="mnemonic">
              <BjInput v-model="form.mnemonic" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.week')" prop="cycleDay">
          <div class="flex-center">
            <el-input-number v-model="form.cycleDay" :min="0" :max="99999" :label="$t('BusinessPurchaseSupplier.dataForm.week')" class="full-width" :controls="false" />
            <span class="ml5">{{ $t('BusinessPurchaseSupplier.dataForm.day') }}</span>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.proportion')" prop="overfillRate">
          <div class="flex-center">
            <el-input-number v-model="form.overfillRate" :min="0" :max="100" :label="$t('BusinessPurchaseSupplier.dataForm.proportion')" class="full-width" :controls="false" />
            <span class="ml5">%</span>
          </div>
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.cooperationDate')" prop="cooperationDate">
          <BjDateTimerPicker v-model="form.cooperationDate" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.invoicing')" prop="invoiceType">
          <BjSelectLov v-model="form.invoiceType" lov-code="SPUR.INVOICE_TYPE" />
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.paymentMethod')" prop="paymentType">
          <BjInput v-model="form.paymentType" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.taxRate')" prop="taxRate">
          <div class="flex-center">
            <el-input-number v-model="form.taxRate" :min="0" :max="100" :label="$t('BusinessPurchaseSupplier.dataForm.taxRate')" class="full-width" :controls="false" />
            <span class="ml5">%</span>
          </div>
        </el-form-item>
      </el-col>
      </el-row>
        <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.taxCode')" prop="taxCode">
          <BjInputCode v-model="form.taxCode" :maxlength="MAX_LENGTH.SHORT_NAME" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.currency')" prop="currency">
          <BjInput v-model="form.currency" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
        <el-col :span="12">
              <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.gl_Account')" prop="glAccount">
                <BjInput v-model="form.glAccount" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.systemCode')" prop="systemCode">
                <BjInput v-model="form.systemCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
              </el-form-item>
            </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.remark')" prop="remark">
          <BjTextarea v-model="form.remark" :placeholder="$t('BusinessPurchaseSupplier.dataForm.remark')" />
        </el-form-item>
      </el-col>
    </template>
    <template>
      <BjDivider>{{ $t('BusinessPurchaseSupplier.dataForm.contact') }}</BjDivider>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.contactPerson')" prop="contactName">
          <BjInput v-model="form.contactName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <BjFormItemEmail v-model="form.contactEmail" :label="$t('BusinessPurchaseSupplier.dataForm.email')" prop="contactEmail" clearable />
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.telephone')" prop="contactTel">
          <BjInput v-model="form.contactTel" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <BjFormItemMobile v-model="form.contactPhone" prop="contactPhone" :label="$t('BusinessPurchaseSupplier.dataForm.phone')" clearable />
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('districtNameText')" prop="contactDistrict">
          <BjInput v-model="form.contactDistrict" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('detailAddressText')" prop="contactAddress">
          <BjInput
            v-model="form.contactAddress"
            :maxlength="MAX_LENGTH.DEFAULT"
            :placeholder="$t('BusinessPurchaseSupplier.dataForm.detailAddress')"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('cityText')" prop="contactCity">
          <BjInput v-model="form.contactCity" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('countryText')" prop="fullAddress">
          <BjRegionCascader v-model="regionList" class="full-width" is-array clearable @change="onChangeRegionCascader" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('postcodeText')" prop="postcode">
          <BjInputCode v-model="form.postcode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-col>
    </template>
    <template>
      <BjDivider>{{ $t('BusinessPurchaseSupplier.dataForm.bankInformation') }}</BjDivider>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.account')" prop="bankName">
          <BjInput v-model="form.bankName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.bankOfDeposit')" prop="bankDeposit">
          <BjInput v-model="form.bankDeposit" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplier.dataForm.bankAccount')" prop="bankAccount">
          <BjInput v-model="form.bankAccount" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
    </template>
  </BjDrawerForm>
</template>
<script>
import { purchaseApi } from '@/api';
import { STATUS_HAVE_TRUE } from '@/utils/constants';
import orderLog from '@/utils/log.js';

const getDefaultForm = () => {
  return {
    bankAccount: null,
    bankDeposit: null,
    bankName: null,
    code: null,
    contactAddress: null,
    contactCity: null,
    contactCityCode: null,
    contactDistrict: null,
    contactDistrictCode: null,
    contactEmail: null,
    contactName: null,
    contactPhone: null,
    contactProvince: null,
    contactProvinceCode: null,
    contactTel: null,
    cooperationDate: null,
    cycleDay: undefined,
    id: null,
    invoiceType: null,
    level: undefined,
    mnemonic: null,
    name: null,
    objectVersionNumber: null,
    overfillRate: 0,
    paymentType: null,
    remark: null,
    status: true,
    taxRate: 0,
    type: null,
    countryName: null,
    countryCode: null,
    postcode: null,
    taxCode: null,
    glAccount: null,
    currency: null,
    systemCode: null,
  };
};

export default {
  data() {
    return {
      STATUS_HAVE_TRUE,
      // 表单参数
      isEdit: false,
      regionList: [],
      form: getDefaultForm(),
    };
  },
  computed: {
    // 表单校验
    rules() {
      const validateFullAddress = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!this.form.countryCode || !this.form.contactProvinceCode) {
            callback(new Error(this.$t('WarehouseManagement.form.Please')));
          }
          callback();
        });
      };
      return {
        code: [{required: true, message: this.$t('BusinessPurchaseSupplier.dataForm.codeRule'), trigger: 'blur'}],
        name: [{required: true, message: this.$t('BusinessPurchaseSupplier.dataForm.nameRule'), trigger: 'blur'}],
        fullAddress: { required: true, validator: validateFullAddress, trigger: 'change' },
        contactCity: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        contactDistrict: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        contactAddress: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        postcode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      };
    },
  },
  watch: {
    regionList(value) {
      this.form.countryCode = (value || [])[0];
      this.form.contactProvinceCode = (value || [])[1];
    },
  },
  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.regionList = [];
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(
        this.isEdit
          ? this.$t('BusinessPurchaseSupplier.dataForm.edit')
          : this.$t('BusinessPurchaseSupplier.dataForm.add'),
      );
      this.form = Object.assign(getDefaultForm(), info || {});
      if (this.isEdit) {
        // 地址回显
        this.regionList = [
          Number(info.countryCode),
          Number(info.contactProvinceCode),
        ];
      }
      if (this.form.level === null) this.form.level = undefined;
      if (this.form.cycleDay === null) this.form.cycleDay = undefined;
    },
    showLog() {
      orderLog(
        this.$BjDialogListConfig['purchaseDefault'](
          this.$t('BusinessPurchaseSupplier.dataForm.warning1') + this.form.code + this.$t(
            'BusinessPurchaseSupplier.dataForm.warning2',
          ),
          {
            defaultQuery: {
              recordId: this.form.id,
              recordType: 'SUPPLIER',
            },
            search: [],
          },
        ),
      );
    },
    onChangeRegionCascader(v) {
      if (v.length > 0) {
        this.form.countryName = v[0].label;
        this.form.countryCode = v[0].value;
        this.form.contactProvince = v[1].label;
        this.form.contactProvinceCode = v[1].value;
      }
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      // 数据处理相关
      API_DATA.overfillRate = this.$number2money(API_DATA.overfillRate);
      API_DATA.taxRate = this.$number2money(API_DATA.taxRate);
      if (this.isEdit) API_DATA['_innerMap'] = {};
      this.sendApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },
    sendApi(API_DATA) {
      purchaseApi[(this.isEdit ? 'put' : 'add') + 'Suppliers'](API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
